import React, { Component } from 'react';
import './App.css';
import $ from 'jquery';
import teamviewer from './img/teamviewer.jpg';
import { Link } from 'react-router-dom';
import eset from './img/eset.jpg';
import microsoft from './img/mslogo.png';
import kaspersky from './img/kaspersky_logo.png';
import mcafee from './img/logo-mcafee.png';
import avast from './img/avast-antivirus-logo.jpg';
import symnatec from './img/symantec.gif';
import acronis from './img/acronis.gif';
import avg from './img/avg12-logo-head.png';

class Podpora extends Component {
    constructor(props){
        super(props);

    }
    componentDidMount(){
        function resetMenu(){
            $("#home a").removeClass("active");
            $("#sluzby-a-produkty-link a").removeClass("active");
            $("#prodej-instalace-li a").removeClass("active");
            $("#lokalni-li a").removeClass("active");
            $("#outsourcing-li a").removeClass("active");
            $("#audit-is-li a").removeClass("active");
            $("#webhosting-li a").removeClass("active");
            $("#webdesign-li a").removeClass("active");
            $("#cenik-praci-li a").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

      $("#podpora-li a").addClass("active");

    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="podpora">
            <h1>Podpora</h1>

            <div className="row">
                <div className="col-sm-4">
                    <a href="http://www.teamviewer.com/cs/download/windows.aspx" target="_blank">
                        <img src={teamviewer}/>
                        <span>TeamViewer</span>
                    </a>
                </div>
                <div className="col-sm-4">
                    <a href="https://www.eset.com/cz/firmy/stahnout/" target="_blank">
                        <img src={eset}/>
                        <span>Eset</span>
                    </a>
                </div>
                <div className="col-sm-4">
                    <a href="https://get.teamviewer.com/tech_qsupport2021" target="_blank">
                        <img src={teamviewer}/>
                        <span>TechQuickSupport</span>
                    </a>
                </div>
            </div>

           {/* <div className="row">
               <div className="col-sm-4">
                   <a href="https://www.antivirovecentrum.cz/kaspersky/download.aspx" target="_blank">
                        <img src={kaspersky} />
                        <span>Kapsersky</span>
                   </a>
                </div>
                <div className="col-sm-4">
                    <a href="https://www.antivirovecentrum.cz/mcafee/download.aspx" target="_blank">
                        <img src={mcafee}/>
                        <span>McAfee</span>
                    </a>
                </div>
                <div className="col-sm-4">
                    <a href="https://www.antivirovecentrum.cz/avast/download.aspx" target="_blank">
                        <img src={avast}/>
                        <span>Avast</span>
                    </a>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-4">
                    <a href="https://www.antivirovecentrum.cz/symantec/download.aspx" target="_blank">
                        <img src={symnatec} />
                        <span>Symnatec</span>
                    </a>
                </div>
                <div className="col-sm-4">
                    <a href="https://www.antivirovecentrum.cz/acronis/download.aspx" target="_blank">
                        <img src={acronis}/>
                        <span>Acronis</span>
                    </a>
                </div>
                <div className="col-sm-4">
                    <a href="https://www.antivirovecentrum.cz/avg/download.aspx" target="_blank">
                        <img src={avg}/>
                        <span>AVG</span>
                    </a>
                </div>
            </div>*/}

        </div>


</div>
    );
  }
}

export default Podpora;



// WEBPACK FOOTER //
// ./src/Podpora.js